/**
 * OAuth 2.0 Configuration for AWS Cognito User Pool Authentication
 *
 * This configuration uses the shared Cognito User Pool from ms-reporting
 * with OpsPilot-specific app client and callback URLs.
 *
 * The Cognito User Pool is federated with Azure Entra ID via SAML
 * (O365fi identity provider, ADR-0051).
 */

const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN;
const COGNITO_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID;
const REDIRECT_URI = import.meta.env.VITE_REDIRECT_URI;

if (!COGNITO_DOMAIN || !COGNITO_CLIENT_ID || !REDIRECT_URI) {
  throw new Error(
    'Missing required Cognito configuration. Please ensure VITE_COGNITO_DOMAIN, ' +
      'VITE_COGNITO_CLIENT_ID, and VITE_REDIRECT_URI are set in environment variables.'
  );
}

export interface OAuthConfig {
  clientId: string;
  domain: string;
  redirectUri: string;
  logoutUri: string;
  authEndpoint: string;
  tokenEndpoint: string;
  logoutEndpoint: string;
  scopes: string[];
}

export const oauthConfig: OAuthConfig = {
  clientId: COGNITO_CLIENT_ID,
  domain: COGNITO_DOMAIN,
  redirectUri: REDIRECT_URI,
  logoutUri: REDIRECT_URI.replace('/auth/callback', '/logout'),
  authEndpoint: `https://${COGNITO_DOMAIN}/oauth2/authorize`,
  tokenEndpoint: `https://${COGNITO_DOMAIN}/oauth2/token`,
  logoutEndpoint: `https://${COGNITO_DOMAIN}/logout`,
  scopes: ['openid', 'email', 'profile'],
};
